import { type FirebaseApp, getApp, getApps, initializeApp } from "firebase/app"
import { clientConfig } from "./clientConfig"

// Single source of truth for the browser-side Firebase app singleton. Both
// `getFirebaseAuth` and `getFirebaseFunctions` build on this so they share one
// app instance instead of independently racing to call `initializeApp`.
export const getFirebaseApp = (): FirebaseApp =>
  getApps().length ? getApp() : initializeApp(clientConfig)
